module.exports = __webpack_public_path__ + "Death Distribution.pdf";